const changeInspectors = [
    {
        "uuid": "1",
        "appNo": "A21122701",
        "appType": "initial",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "oldInspectors": {
            "inspectionDateOrManDay": "inspectionDate",
            "defaultArea": "north",
            "inspectionDates" : [
                {"inspectionDate": "2021-10-19T00:00:00.000Z"},
                {"inspectionDate": "2021-10-21T00:00:00.000Z"},
            ],
            "inspectors": [
                {"role": "lead", "area": "north", "name": "獨立稽核員1", "inspectionDates": ["2021-10-19T00:00:00.000Z", "2021-10-21T00:00:00.000Z"]},
                {"role": "inspector", "area": "north", "name": "獨立稽核員2", "inspectionDates": ["2021-10-19T00:00:00.000Z", "2021-10-21T00:00:00.000Z"]},
            ],
        },
        "newInspectors":{
            "inspectionDateOrManDay": "inspectionDate",
            "defaultArea": "north",
            "inspectionDates": [
                {"inspectionDate": "2021-10-19T00:00:00.000Z"},
                {"inspectionDate": "2021-10-21T00:00:00.000Z"},
            ],
            "inspectors": [
                {"role": "lead", "area": "north", "name": "獨立稽核員北1"},
                {"role": "inspector", "area": "north", "name": "獨立稽核員北2"},
            ],
        },
    },
    {
        "uuid": "2",
        "appNo": "A21122704",
        "appType": "initial",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "oldInspectors": {
            "inspectionDateOrManDay": "manDay",
            "defaultArea": "north",
            "manDay": 4,
            "inspectors": [
                {"role": "lead", "area": "north", "name": "獨立稽核員1", "manDay": 4},
                {"role": "inspector", "area": "north", "name": "獨立稽核員2", "manDay": 2},
            ],
        },
        "newInspectors":{
            "inspectionDateOrManDay": "manDay",
            "defaultArea": "north",
            "manDay": 4,
            "inspectors": [
                {"role": "lead", "area": "north", "name": "獨立稽核員北1"},
                {"role": "inspector", "area": "north", "name": "獨立稽核員北2"},
            ],
        },
    },
]

export default changeInspectors;